import { Breadcrumb, Container } from "react-bootstrap";
import clsx from "classnames";
import classes from "./styles.module.scss";
import PropTypes from "prop-types";
import { getRoute } from "@/functions/getRoute";
import Home from "@/assets/Home.svg";

export default function BreadcrumbNavigation({ className, items }) {
  return (
    <div className={clsx(className, classes.breadcrumbs)}>
      <Container className="mw-xxl">
        <Breadcrumb>
          <Breadcrumb.Item href={getRoute("home")}>
            <Home /> Tate
          </Breadcrumb.Item>
          {items.map(({ label, href }, k) => (
            <Breadcrumb.Item key={k} href={href}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="41" viewBox="0 0 16 41" fill="none">
                <path d="M1 0.5L15 20.5L1 40.5" stroke="#C8CDCD" />
              </svg>
              {label}
            </Breadcrumb.Item>
          ))}
        </Breadcrumb>
      </Container>
    </div>
  );
}

BreadcrumbNavigation.defaultProps = {
  className: "",
  items: [],
};

BreadcrumbNavigation.propTypes = {
  className: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      href: PropTypes.string,
    }),
  ),
};
